import config from '../configuration/configuration';
import { registerSyfEventListener, unregisterSyfEventListener } from './syf-common-utils';

let syfFrameFirstLoad = false;
export function openSYFModal(syfEmpqObject) {
    registerSyfEventListener();
    let modalElementId = config[config.env].syfIframeModalHolderId;
    //check if modal id does not exist
    if (!document.getElementById(modalElementId)) {
        let modalDiv = document.createElement("div");
        modalDiv.id = modalElementId;
        document.body.appendChild(modalDiv);
    }
    let modalTemplate = getGenericSYFModalTemplate();
    loadModalInDOM(modalElementId, modalTemplate);
    modalActionOnDOMAttach(syfEmpqObject);
    if (document.getElementById("syfIframeCrossIcon")) {
        document.getElementById("syfIframeCrossIcon").addEventListener('click', () => {
            syfEmpq.syfProduct.activeProduct.closeModal();
        });

        document.getElementById("syfIframeCrossIcon").addEventListener('keypress', (event) => {
            syfEmpq.syfProduct.activeProduct.closeModalWithKeyboard(event)
        });
    }

    if (document.getElementsByClassName('syf-iframe-chng-height')) {
        if ((window.parent.innerHeight - 20) < 700) {
            document.getElementsByClassName('syf-iframe-chng-height')[0].style.height = window.innerHeight + 'px';
        } else {
            document.getElementsByClassName('syf-iframe-chng-height')[0].style.height = window.parent.innerHeight - 20 + 'px';
        }
    }

}
export function modalActionOnDOMAttach(syfEmpqObject) {
    const { syfPartnerId = "", siteCode = "", datashareToken = "", operatorId = "" } = syfEmpqObject

    let modalURL = `${config[config.env].syfMPPCoreURL}empq?modalapply=true&partnerId=${syfPartnerId}&siteCode=${siteCode}&datashareToken=${datashareToken}`

    if (operatorId) modalURL += '&operatorId=' + operatorId;

    let destinationURLWithVisitorIDs = modalURL;

    document.getElementById('syfFrame').src = destinationURLWithVisitorIDs.toString();
}
export function modalContainerLoadEvent() {
    document.getElementById("syfFrame").style.background = `url(${config[config.env].syfLogoURL}) center center no-repeat`;

    //height adjustment for mobile devices
    if (window.matchMedia("(max-width: 767px)").matches) {
        document.getElementsByClassName("syf-iframe-modal-open")[0].style.position =
            "fixed";
    }
    //focus close button on modal open
    if (document.getElementById("syfIframeCrossIcon") != null) {
        document.getElementById("syfIframeCrossIcon").focus();
        document
            .getElementById("syfIframeCrossIcon")
            .addEventListener("keydown", function (event) {
                if (event.shiftKey && event.key === "Tab") {
                    event.preventDefault();
                }
            });
    }
};
export function loadModalInDOM(modalId, modalTemplate) {
    document.getElementById(modalId).innerHTML = modalTemplate;
    document.body.classList.add("syf-iframe-modal-open");
    document.getElementById("syfFrame").onload = modalContainerLoadEvent();

    if (!syfFrameFirstLoad) {
        document.getElementById("syfFrame").addEventListener("load", () => {
            document.getElementById("syfFrame").style.background = "none";
            syfFrameFirstLoad = true;
        })
    }
};
export function registerOfferEventListener() {
    window.onresize = function () {
        let parentHeight = window.parent.innerHeight - 20;
        let parentWidth = window.parent.innerWidth;
        if (parentWidth <= 767 && window.innerHeight < parentHeight) {
            window.innerHeight = parentHeight;
        }
        if ((window.innerHeight - 20) < 700) {
            document.getElementsByClassName('syf-iframe-chng-height')[0].style.height = window.innerHeight + 'px';
        } else {
            document.getElementsByClassName('syf-iframe-chng-height')[0].style.height = window.innerHeight - 20 + 'px';
        }
    }

}

// creating modal template with class and id names
export function getGenericSYFModalTemplate() {
    let modalTemplate = '<div class="syf-iframe-modal syf-iframe-fade syf-iframe-in" id="syfModal" role="dialog" tabindex="-1" '
        + 'aria-labelledby="SYF Modal">'
        + '<div class="syf-iframe-modal-dialog" role="document">'
        + '<div class="syf-iframe-modal-content"><div class="syf-iframe-chng-height">'
        + '<div class="syfIframeClose-bt-full"  id="syf-iframe-close-btn-new">'
        + '<div tabindex="0" id="syfIframeCrossIcon"'
        + '	class="syf-iframe-close" aria-label="Close"'
        + '	>'
        + '	<img alt="close" id="syfIframeCloseBtn"  src="'
        + config[config.env].syfXIamageUL
        + '" class="syf-iframe-modal-XImage">'
        + '</div>'
        + '</div>'
        + '<iframe id="syfFrame" name="syfFrame" title="SYF MultiProduct Platform" frameborder="0px" style="width:100%;height:100%;border:none;"></iframe></div></div></div></div>';
    return modalTemplate;
}

// if scriptid not found in merchant site then identifying the integration file 
export function getModalScriptElementOnMissingId() {
    let scripts = document.getElementsByTagName('script');
    let scriptElement = null;
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.indexOf("syf-integration.js") >= 0) {
            scriptElement = scripts[i];
        }
    }
    return scriptElement;
}
export function closeModal() {
    syfCloseModalEvent();
    document.getElementById("syfModal").style.display = "none";
    document.getElementsByClassName("syf-iframe-modal-open")[0].style.position =
        "relative";
    document.body.classList.remove("syf-iframe-modal-open");
    unregisterSyfEventListener();
}
// Before closing the modal sending event for merchant
const syfCloseModalEvent = () => {
    window.postMessage("Syf Modal Close", "*");
};
